import { equals } from "ramda";

import {
	isLogItemWithPath,
	LogItem,
	RemoteOption,
	Value
} from "lib/build/schema";

export function removeInactiveOptions(messages: LogItem[]): LogItem[] {
	return messages.map(msg => {
		if (!hasOptions(msg)) {
			return msg;
		}
		const options = (msg.details.options as RemoteOption[]).filter(
			option => option.inactive === false
		);
		return { ...msg, details: { ...msg.details, options } };
	});
}

export function addMaxItems(messages: LogItem[]): LogItem[] {
	const msgA = findConnectedUsersMessage(messages);
	if (msgA === undefined) {
		return messages;
	}
	const msgB = findConnectedUserMessage(messages, 0);
	if (msgB === undefined || !hasOptions(msgB)) {
		return messages;
	}
	const maxItems = msgB.details.options.length;
	return messages.map(msg =>
		msg === msgA ? { ...msg, details: { ...msg.details, maxItems } } : msg
	);
}

export function removeSelectedOptions(
	root: Value,
	messages: LogItem[]
): LogItem[] {
	if (!hasConnectedUsers(root)) {
		return messages;
	}
	const values: (string | undefined)[] = root.value.connectedUsers;
	return messages.filter(isLogItemWithPath).map(msg => {
		if (!hasOptions(msg)) {
			return msg;
		}
		const index = msg.path[msg.path.length - 1] as number;
		const options = (msg.details.options as RemoteOption[]).filter(
			option =>
				!values.includes(option.value) || values[index] === option.value
		);
		return { ...msg, details: { ...msg.details, options } };
	});
}

function hasConnectedUsers(
	value: Value
): value is { value: { connectedUsers: (string | undefined)[] } } {
	return "value" in value && "connectedUsers" in value.value;
}

function findConnectedUsersMessage(messages: LogItem[]): LogItem | undefined {
	return messages.find(
		msg =>
			isLogItemWithPath(msg) &&
			equals(msg.path, ["value", "connectedUsers"])
	);
}

function findConnectedUserMessage(
	messages: LogItem[],
	index: number
): LogItem | undefined {
	return messages.find(
		msg =>
			isLogItemWithPath(msg) &&
			equals(msg.path, ["value", "connectedUsers", index])
	);
}

function hasOptions(
	msg: LogItem
): msg is LogItem & { details: { options: RemoteOption[] } } {
	return "options" in msg.details;
}
